module.exports = __webpack_public_path__ + "06_medium_gold.21ea433f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/06_medium_gold.png
// module id = fOLi
// module chunks = 0